/*
 * @title: 
 * @Author: wangshuai
 * @Date: 2024-10-30 15:46:32
 * @FilePath: \飞行-运控\src\api\model\materials.js
 * @Description: 申请资料模块接口
 * 
 */
import config from "@/config";
import http from "@/utils/request";

export default {
	addApplicationMaterials: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/addApplicationMaterials`,
		name: "申请资料-添加申请资料",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	updateApplicationMaterials: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/updateApplicationMaterials`,
		name: "申请资料-修改申请资料",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},	
	queryApplicationMaterials: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/queryApplicationMaterials`,
		name: "申请资料-查询申请资料",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},	
};
